import MomentUtils from "@date-io/moment";
import {
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import moment from "moment";
import "moment/locale/en-ca";
import "moment/locale/vi";
import React, { useState } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

function TimePicker(props = {}) {
  const { value, i18n, t, ...other } = props;
  const [selectedDate, setSelectedDate] = useState();

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (props.handleChange) {
      props.handleChange(new Date(date).getTime());
    }
  };
  return (
    // <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <MuiPickersUtilsProvider
      libInstance={moment}
      utils={MomentUtils}
      locale={i18n.language === "vn" ? "vi" : "en"}
    >
      <KeyboardTimePicker
        {...other}
        inputVariant="outlined"
        value={new Date(value)}
        onChange={handleDateChange}
        cancelLabel={t("date_picker_cancel")}
        okLabel={t("date_picker_ok")}
      />
    </MuiPickersUtilsProvider>
  );
}

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(TimePicker));
